import { CommonEditLogic } from './common-edit-logic';

export class SmartArtEditLogic extends CommonEditLogic {
}
